import EvaluacionDisciplinaOperativa from '../../domain/entities/EvaluacionDisciplinaOperativa'
import { getProcedimientos } from '../../domain/rules/evaluacionDisciplinaOperativa.rules'
import EvaluacionDisciplinaOperativaAdapter from '../adapters/EvaluacionDisciplinaOperativa.adapter'

export default class CreateEvaluacionDisciplinaOperativaUseCase {
  #repository

  constructor(repository) {
    this.#repository = repository
  }

  async execute(evaluacionDesempenio) {
    try {
      const evaluacion = new EvaluacionDisciplinaOperativa(evaluacionDesempenio.idEvaluado)
      evaluacion.idEvaluador = evaluacionDesempenio.idEvaluador
      evaluacion.idPeriodicidad = evaluacionDesempenio.idPeriodicidad
      evaluacion.fechaInicio = evaluacionDesempenio.fechaInicio
      evaluacion.fechaConclusion = evaluacionDesempenio.fechaConclusion
      evaluacion.fechaAplicacion = evaluacionDesempenio.fechaAplicacion

      const procedimientos = await this.#repository.getProcedimientos(evaluacionDesempenio.idEvaluado)
      evaluacion.procedimientos = getProcedimientos(procedimientos, evaluacionDesempenio.fechaAplicacion)

      const dto = EvaluacionDisciplinaOperativaAdapter.toDto(evaluacion)
      const { data } = await this.#repository.create(dto)

      return data[0].ID
    } catch (error) {
      throw new Error(`Failed to execute CreateEvaluacionDisciplinaOperativaUseCase: ${error.message}`)
    }
  }
}
